export const FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE = 'Content/FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE';
export const FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_SUCCESS = 'Content/FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_SUCCESS';
export const FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_FAILURE = 'Content/FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_FAILURE';

export const FETCH_CONTENT = 'Content/FETCH_CONTENT';
export const FETCH_CONTENT_SUCCESS = 'Content/FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_FAILURE = 'Content/FETCH_CONTENT_FAILURE';

export const REMOVE_CONTENT = 'Content/REMOVE_CONTENT';
export const REMOVE_CONTENT_SUCCESS = 'Content/REMOVE_CONTENT_SUCCESS';
export const REMOVE_CONTENT_FAILURE = 'Content/REMOVE_CONTENT_FAILURE';

export const SAVE_CONTENT = 'Content/SAVE_CONTENT';
export const SAVE_CONTENT_SUCCESS = 'Content/SAVE_CONTENT_SUCCESS';
export const SAVE_CONTENT_FAILURE = 'Content/SAVE_CONTENT_FAILURE';

export const CLEAR_CONTENT_TO_PREVIEW = 'Content/CLEAR_CONTENT_TO_PREVIEW';
export const CLEAR_CONTENT_SINGLE = 'Content/CLEAR_CONTENT_SINGLE';
export const EMPTY_CONTENT = 'Content/EMPTY_CONTENT';
export const SET_CONTENT_SINGLE = 'Content/SET_CONTENT_SINGLE';
export const SET_CONTENT_PIECE_TO_PREVIEW = 'Content/SET_CONTENT_PIECE_TO_PREVIEW';
export const SET_CONTENT_SET_TO_PREVIEW = 'Content/SET_CONTENT_SET_TO_PREVIEW';
export const UPDATE_CONTENT = 'Content/UPDATE_CONTENT';
export const UPDATE_SEARCH_TERM = 'Content/UPDATE_SEARCH_TERM';
export const UPDATE_FILE_TO_UPLOAD = 'Content/UPDATE_FILE_TO_UPLOAD';



// WEBPACK FOOTER //
// ./src/containers/ContentPage/store/constants.js